export default "/images/voucher.png?91cf815b90ee02a4c1a4249e1e69e3d5";